import React from "react";
// Deliberately small, safe subset: paragraphs, #/##/### headings, "- " lists,
// [text](https://…) links and ![alt](/media/… "caption") images. Strings
// remain React text nodes; raw HTML is never parsed. Links are limited to
// http(s) and images to this site's uploaded media.
const LINK_RE = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g;
const IMAGE_RE = /^!\[([^\]\n]*)\]\((\/media\/[a-zA-Z0-9-]+\.(?:jpg|png|webp))(?:\s+"([^"\n]*)")?\)$/;

export function inline(text: string): React.ReactNode[] {
  const out: React.ReactNode[] = [];
  let last = 0,
    m: RegExpExecArray | null;
  const re = new RegExp(LINK_RE);
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push(
      <a key={m.index} href={m[2]} target="_blank" rel="noopener noreferrer">
        {m[1]}
      </a>,
    );
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export default function MarkdownBody({ text }: { text: string }) {
  return (
    <div className="er-blog-body">
      {text
        .split(/\n\s*\n/)
        .filter((b) => b.trim())
        .map((block, i) => {
          const lines = block.trim().split("\n");
          if (lines.every((l) => l.startsWith("- ")))
            return (
              <ul key={i}>
                {lines.map((l, j) => (
                  <li key={j}>{inline(l.slice(2))}</li>
                ))}
              </ul>
            );
          const img = block.trim().match(IMAGE_RE);
          if (img)
            return (
              <figure key={i}>
                <img src={img[2]} alt={img[1]} loading="lazy" />
                {img[3] && <figcaption>{img[3]}</figcaption>}
              </figure>
            );
          const m = block.trim().match(/^(#{1,3})\s+([^\n]+)$/);
          if (m)
            return m[1].length === 1 ? (
              <h2 key={i}>{m[2]}</h2>
            ) : (
              <h3 key={i}>{m[2]}</h3>
            );
          return <p key={i}>{inline(block)}</p>;
        })}
    </div>
  );
}
